import React, { Component } from "react";
import styles from "assets/jss/material-kit-react/views/landingPage.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Parallax from "components/Parallax/Parallax.js";
import classNames from "classnames";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import Clue from "./Clue";
import { Link } from "react-router-dom";
import Logo from "../../../assets/img/ASA LOGO ONLY.png";

class Home extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Parallax
          filter
          style={{ height: 650 }}
          image={require("assets/img/background.jpeg")}
        >
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={7}>
                <img src={Logo} alt="logo" style={{ width: "100%" }} />
                {/* <h1 className={classes.title} style={{marginBottom:0}}>Layanan Administrasi</h1>
                        <h2 className={classes.title} style={{marginTop:0}}>Universitas Sumatera Utara</h2>                         */}
              </GridItem>
              <GridItem xs={12} sm={12} md={5} style={{ marginTop: 80 }}>
                <h4>
                  {/* ASA (Apilkasi Satu Atap)  merupakan aplikasi website dimana mempermudah 
                                interaksi antara Tata Usaha dengan Mahasiwa untuk berbagai 
                                kebutuhan surat-menyurat. Pilih jenis surat yang anda butuhkan. */}
                  ASA (Aplikasi Satu Atap) merupakan aplikasi daring untuk
                  mempermudah layanan administrasi akademik mahasiswa.
                </h4>
                <br />
                <Link to="/daftar-surat">
                  <Button color="info" size="lg" rel="noopener noreferrer">
                    <i className="fas fa-play" />
                    Ajukan Sekarang
                  </Button>
                </Link>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            {/* <Features /> */}
            <Clue />
          </div>
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Home);
